import type { FsnbWorkCard } from '@shared/api';
import { fmtNum } from '@shared/lib/smetaLabels';
import { ContentList, Meta, Muted, MutedNote, Name, Section, SectionTitle } from '../styles';
import { SectionsPath } from './SectionsPath';
import { ResourcesTable } from './ResourcesTable';
import { AbstractTable } from './AbstractTable';
import { CoefficientsTable } from './CoefficientsTable';

export function WorkCardBody({
  card,
  onOpenResource,
  onOpenCoefficient,
}: {
  card: FsnbWorkCard;
  onOpenResource?: (source: string, code: string) => void;
  onOpenCoefficient?: (code: string) => void;
}) {
  const w = card.work;
  const coefs = card.coefficients ?? [];
  return (
    <>
      <Name>{w.name}</Name>
      <Meta>
        <span>
          Измеритель: <strong>{w.unit ?? '—'}</strong>
        </span>
        {(w.nr_code || w.sp_code) && (
          <span>
            НР: <strong>{w.nr_code ?? '—'}</strong> · СП: <strong>{w.sp_code ?? '—'}</strong>
          </span>
        )}
      </Meta>
      <Section>
        <SectionTitle>Где лежит</SectionTitle>
        <SectionsPath card={card} />
      </Section>
      <Section>
        <SectionTitle>Состав работ</SectionTitle>
        {w.content.length > 0 ? (
          <ContentList>
            {w.content.map((c, i) => (
              <li key={i}>{c}</li>
            ))}
          </ContentList>
        ) : (
          <Muted>Состав работ в сборнике не приведён.</Muted>
        )}
      </Section>
      <Section>
        <SectionTitle>Ресурсы на измеритель нормы</SectionTitle>
        <ResourcesTable lines={card.resources} onOpenResource={onOpenResource} />
      </Section>
      {(card.abstract_resources?.length ?? 0) > 0 ? (
        <Section>
          <SectionTitle>Материалы по проекту — из технологических групп</SectionTitle>
          <AbstractTable
            items={card.abstract_resources ?? []}
            groupsLoaded={card.tech_groups_loaded ?? false}
            onOpenResource={onOpenResource}
          />
        </Section>
      ) : (
        card.abstract_loaded === false && (
          <Section>
            <SectionTitle>Материалы по проекту</SectionTitle>
            <Muted>
              Материалы из технологических групп в эту редакцию не загружены — в составе выше их
              нет.
            </Muted>
          </Section>
        )
      )}
      <Section>
        <SectionTitle>
          Поправочные коэффициенты{coefs.length > 0 ? `: ${fmtNum(coefs.length)}` : ''}
        </SectionTitle>
        {coefs.length > 0 ? (
          <>
            <CoefficientsTable
              items={coefs}
              baseType={w.base_type}
              onOpenCoefficient={onOpenCoefficient}
            />
            <MutedNote>
              Рекомендуемая привязка ГГЭ: коэффициент к норме, её таблице или сборнику. Значения
              умножают расход по составляющей; «—» — к ней не применяется. Формула от N — N
              определяется по условию в наименовании.
            </MutedNote>
          </>
        ) : (
          <Muted>
            {card.coefficients_loaded
              ? 'Поправочных коэффициентов к этой норме в привязке ГГЭ нет.'
              : 'Поправочные коэффициенты в эту редакцию не загружены.'}
          </Muted>
        )}
      </Section>
    </>
  );
}
